import { render, staticRenderFns } from "./index.vue?vue&type=template&id=52713463&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=52713463&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52713463",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52713463')) {
      api.createRecord('52713463', component.options)
    } else {
      api.reload('52713463', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=52713463&scoped=true", function () {
      api.rerender('52713463', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/module/4-1-img-list-1/index.vue"
export default component.exports